export default "/assets/images/unit-slide1.6fedb203907b04ab.webp";